/**
 * Phase 1: Centralized Dashboard Statistics Hook
 * 
 * Migrated to use centralized query service for deduplication and caching.
 * Maintains backward compatibility with existing components.
 */

import { useDashboardStatsQuery } from '../services/queryService';

/**
 * Hook that provides dashboard statistics with loading/error states
 * and backwards-compatible interface for existing components
 * 
 * Phase 1: Now uses centralized React Query for deduplication
 */
export const useDashboardStatistics = () => {
  const { 
    data: statistics, 
    isLoading, 
    isError, 
    error, 
    refetch,
    isFetching 
  } = useDashboardStatsQuery();

  // Determine if the statistics are empty (no meaningful data)
  const isEmpty = !statistics || Object.keys(statistics).length === 0;

  return {
    statistics,
    isEmpty,
    isLoading,
    isError,
    error,
    refetch,
    isFetching
  };
};
